import { getOrCreateMarketingVisitorId } from "@/lib/marketing-analytics/visitor";

/** Same id as marketing tracking — keeps demo rate limits on one person. */
export function getOrCreateDemoLeadVisitorToken(): string {
  return getOrCreateMarketingVisitorId();
}
